import styled from '@emotion/styled';

const Container = styled.div`
  position: absolute;
  background-color: var(--dk-bg, white);
  border-radius: 4px;
  border: 1px solid black;
  width: 100%;
  z-index: 1;
  margin-top: 12px;
`;

const StyledAllLabel = styled.div`
  display: flex;
  font-size: 14px;
  align-items: center;
`;

const StyledInput = styled.input`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

const StyledNumber = styled.span`
  font-weight: 500;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export {
  Container,
  StyledAllLabel,
  StyledInput,
  StyledNumber,
  ContentContainer,
};
